import { Form } from "antd";
import { useState } from "react";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { StorageService } from "../../core/_request";
import { createFormData } from "../../../../utilities/formData";
import { HttpStatusCode } from "axios";
import { toast } from "sonner";
import { SimpleInput } from "../../../../common/components/simpleInput/SimpleInput";
import { UploadInputFile } from "../../../../common/components/Upload/UploadInputFile";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { API_BASE_URL } from "../../../../utilities/API_CONSTANT";
import { AiOutlineCloudDownload } from "react-icons/ai";
import style from "./style.module.scss";

type PropsType = {
  onFinish: () => void;
};

export const UploadTerrePlein = ({ onFinish }: PropsType) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {    
    //e.preventDefault();
    try {
      setIsLoading(true);

      const file = values?.file?.[0]?.originFileObj; 

      const dataToPost = {
        file,
      };

      const res = await StorageService.importGateInFile(
        createFormData(dataToPost)
      );

      if (res?.status === HttpStatusCode.Ok) {
        toast.success(res?.data?.message);
        onFinish();
      }
    } catch (_: any) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FormProvider
      Form={Form}
      form={form}
      debug
      onFinish={(values) => {
        handleSubmit(values);
      }}
      onFinishFailed={(err) => {
        console.log("err", err);
      }}
    >
      <SimpleInput
        Form={Form}
        name={"file"}
        rules={[
          {
            required: true,
            message: "Veuillez remplir le champ.",
          },
        ]}
        customInput={<UploadInputFile isExcelOnly />}
      />

<div className={style.entry_voucher__link_wrapper}>
                  <a
                    href={`${API_BASE_URL}/templates/bon_entree.xlsx`}
                    download
                    target="_blank"
                    className={style.entry_voucher__link}
                  >
                    <AiOutlineCloudDownload
                      className={style.entry_voucher__link_icon}
                    />{" "}
                    Télécharger le modèle
                  </a>
                </div>

      <div className="d-flex w-full justify-content-end mt-4">
        <CustomButton type="submit" isLoading={isLoading}>
          Importer
        </CustomButton>
      </div>
    </FormProvider>
  );
};
